<template>
    <div class="availability-bookingtype">
        <toggle
            v-if="canPrebook || canPastbook.allow"
            :can-prebook="canPrebook"
            :can-pastbook="canPastbook"
        />
        <book-now v-if="booking_type === 'now'" />
        <book-later v-else-if="booking_type === 'future'" />
        <book-earlier v-else-if="booking_type === 'past'" :can-pastbook="canPastbook" :can-prebook="canPrebook" />
        <details-grid />
    </div>
</template>

<script>
    import { minimumShortTermDate, minimumShortTermDateNow, defaultShortTerm, defaultShortTermEnd } from '../../../modules/dates';
    import storeFormSync from '../../../store/form-sync';
    import { mapReducers } from '../../../modules/reducer';
    import SaneDates from '../../mixins/SaneDates';
    import Toggle from './phonepay-checker/Toggle';
    import BookNow from './phonepay-checker/BookNow';
    import BookLater from './phonepay-checker/BookLater';
    import DetailsGrid from './phonepay-checker/DetailsGrid';
    import BookEarlier from 'assets/js/components/space/availability-checker/phonepay-checker/BookEarlier';

    export default {
        name: 'pay-by-phone-checker',

        components: {
            BookEarlier,
            Toggle,
            BookNow,
            BookLater,
            DetailsGrid,
        },

        mixins: [SaneDates],

        props: {
            space: {
                type: Object,
                default() {
                    return {};
                },
            },

            canPrebook: {
                type: Boolean,
                default() {
                    return false;
                },
            },

            canPastbook: {
                type: Object,
                default() {
                    return {};
                },
            },
        },

        computed: {
            ...storeFormSync([
                'booking.reservation_details.bookings[0].start_date',
                'booking.reservation_details.bookings[0].start_time',
                'booking.reservation_details.bookings[0].end_date',
                'booking.reservation_details.bookings[0].end_time',
                'booking.reservation_details.bookings[0].quote',
            ]),

            ...mapReducers('$store.state.booking.reservation_details', 'booking/updateReservationData', [
                'booking_type',
            ]),
        },

        watch: {
            booking_type: {
                handler(val) {
                    if (val === 'now') {
                        return this.updateDateTimes();
                    }

                    this.resetDefaultDates();
                },
                immediate: true,
            },
        },

        methods: {
            /**
             * Update the start / end times depending on the duration selected for the booking and whether it is now or later
             */
            updateDateTimes() {
                const minimumDateFunction = (this.booking_type === 'now' ? minimumShortTermDateNow() : minimumShortTermDate() );
                const endDateTime = minimumDateFunction.add(this.bookingDuration, 'minutes');

                this.start_date = minimumDateFunction.format('DD-MM-YYYY');
                this.start_time = minimumDateFunction.format('HH:mm');
                this.end_date = endDateTime.format('DD-MM-YYYY');
                this.end_time = endDateTime.format('HH:mm');
            },

            /**
             * Reset the dates back to the default start / end dates if a user chooses to book for later
             */
            resetDefaultDates() {
                const startEndDate = defaultShortTerm().format('DD-MM-YYYY');

                this.start_date = startEndDate;
                this.start_time = defaultShortTerm().format('HH:mm');
                this.end_date = startEndDate;
                this.end_time = defaultShortTermEnd().format('HH:mm');
            },
        },
    };
</script>

<style lang="less">
    @import "../../../../less/variables.less";
    @import (reference) "../../../../../../node_modules/bootstrap/less/mixins/grid.less";
    @import (reference) "../../../../../../node_modules/bootstrap/less/mixins/clearfix.less";

    .availability-bookingtype {
        h5 {
            text-transform: none;
            letter-spacing: normal;
            color: #000000;
            font-size: 16px;
            margin-bottom: 15px;
            font-weight: 700;
            margin-top: 15px;
        }

        .btn-group {
            margin-bottom: 15px;
        }

        .form-groups {
            .form-group {
                @media (min-width: @screen-md-min) {
                    width: 1%;
                }

                &:first-of-type {
                    padding-right: 5px;

                    .input-chevron-icon {
                        right: 15px;
                    }
                }

                &:last-of-type {
                    padding-left: 5px;
                }
            }
        }
    }
</style>
